import React from "react";
import { LinearProgress } from "@mui/material";
import cls from "./MflistExcelinput.module.css";

export default function BulkInputFooter({
  mode,
  validationCounts,
  isSaving,
  saveProgress,
  canSaveProduction,
  canExportDemo,
  onSaveProduction,
  onExportDemo,
  onAutoCorrect,
  onClose,
}) {
  const hq =
    typeof localStorage !== "undefined" ? (localStorage.hq || "").trim() : "";

  return (
    <div className={cls.footer}>
      <div style={{ fontSize: "0.78rem", color: "#444", minWidth: 140 }}>
        <div>{mode === "training" ? "훈련모드" : "실데이터 모드"}</div>
        <div style={{ color: "#888" }}>현재 본부: {hq || "-"}</div>
      </div>

      <div className={cls.footerHint}>
        {mode === "production" ? (
          validationCounts.errors > 0 ? (
            <>오류 {validationCounts.errors}건 — 보정 후 재검증하세요</>
          ) : (
            <>오류 0건이 되어야 [실데이터 저장]이 활성화됩니다</>
          )
        ) : (
          <>훈련 데이터는 DB에 저장되지 않습니다</>
        )}
        {isSaving && (
          <div style={{ marginTop: 4 }}>
            저장 중 {saveProgress.done}/{saveProgress.total}
            <LinearProgress sx={{ mt: 0.5 }} />
          </div>
        )}
      </div>

      <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
        {mode === "production" && (
          <button type="button" className={cls.btnSecondary} onClick={onAutoCorrect}>
            자동 보정
          </button>
        )}
        {mode === "production" ? (
          <button
            type="button"
            className={cls.btnPrimary}
            disabled={!canSaveProduction || isSaving}
            onClick={onSaveProduction}
          >
            🔒 실데이터 저장
          </button>
        ) : (
          <>
            <button
              type="button"
              className={cls.btnPrimary}
              disabled={!canExportDemo}
              onClick={onExportDemo}
            >
              결과 저장(시연용)
            </button>
            <button type="button" className={cls.btnSecondary} disabled title="훈련모드">
              DB 저장
            </button>
          </>
        )}
        <button type="button" className={cls.btnSecondary} onClick={onClose}>
          {mode === "training" ? "닫기" : "취소"}
        </button>
      </div>
    </div>
  );
}
